module.exports = __webpack_public_path__ + "static/img/expressway-text-6.5d44bb3a.png";